<template>
  <div id="app" :class="{'normal-state': !showBar}">
    <div class="top-bar" v-if="showBar">
        <img class="logo" :src="appInfo.app_logo" width="36" height="36" alt="">
        <div class="text">
            <p class="name">{{appInfo.app_name}}</p>
            <p class="desc">{{appInfo.app_des}}</p>
        </div>
        <span class="btn-close" @click="showBar=false"></span>
        <span v-show="themecolor" @click="jumpToAppPage" class="btn-openapp magx-btn theme-bg-color">立即打开</span>
    </div>
    <div class="app-jump-overlay overlay">
        <div class="app-jump-dialog dialog">
            <img class="app-logo" v-lazy="appInfo.app_logo" width="78" height="78" />
            <p class="des" v-if="isInWeixin">QQ／微信内限制无法进行此操作，请打开客户端后重试</p>
            <a v-if="!isInWeixin" class="button button-installed theme-bg-color">已安装&nbsp;&gt;&nbsp;打开应用查看本页</a>
            <a :href="appInfo.app_download" class="button theme-bg-color">未安装&nbsp;&gt;&nbsp;前去下载客户端</a>
        </div>
    </div>
    <div class="fixed-btm-icons">
      <router-link
        :to="{path: '/'}"
        v-show="showFixedIndex"
        tag="div"
        class="item">
        <span class="icon icon-gohome"></span>
        <span class="name">首页</span>
      </router-link>
      <div class="item" v-show="showPostForum" @click="goPostForum">
        <span class="icon icon-post-forum"></span>
        <span class="name">发帖</span>
      </div>
      <div class="item" v-show="showPostWshare" @click="goPostWshare">
        <span class="icon icon-post-topic"></span>
        <span class="name">拍摄</span>
      </div>
    </div>

    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view> -->
    
    <keep-alive>
      <router-view></router-view>
    </keep-alive>

  </div>
</template>

<script>
import router from './router'

window.AppJumpProtocol = '';
window.AppThemeColor = '';

export default {
  data (){
    return {
      themecolor: '',
      isLimited: false,
      showFixedIndex: false,
      showPostForum: false,
      showPostWshare: false,
      showBar: false,
      appInfo: {},
      isInWeixin: this.$utils.pageIsInThirdPlatform(),
    }
  },
  watch: {
    '$route': function () {
      var routeName = this.$route.name;
      if(routeName !== 'UserHome' && routeName !== 'CirclePostList' && routeName !== 'WshareList' && routeName !== 'TopicIndex'){
        this.$utils.setShareData();
      }
      document.title = this.$route.meta.title ? this.$route.meta.title : '';
      this.showFixedIndex = routeName !== 'Entry' && routeName !== 'Index' && routeName !== 'Circle' && routeName !== 'Find' && routeName !== 'User'  && routeName !== 'CirclePost' && routeName !== 'WsharePost' && routeName !== 'Wshare';
      this.showBar = routeName !== 'CirclePost' && routeName !== 'WsharePost' && routeName !== 'merchantList';
      this.showPostForum = routeName === 'CirclePostList' || routeName === 'merchantCircle';
      this.showPostWshare = routeName === 'WshareList' || routeName === 'TopicIndex' || routeName === 'Wshare';
    }
  },
  created (){
    var me = this;
    var doc = document,
        themecolor = '',
        mystyle = doc.createElement('style');
    mystyle.setAttribute('type', 'text/css');
    this.$store.dispatch('loadGlobalConfig').then((data) => {
      me.appInfo = data.appInfo;
      me.isLimited = parseInt(data.global_wap_limited_interaction) === 1;
      window.ShareTitle = data.appInfo.app_name;
      window.ShareDesc = data.appInfo.app_des;
      window.ShareIcon = data.appInfo.app_logo;
      me.$utils.setShareData();
      window.AppJumpProtocol = data.appInfo.app_key;
      if(data.global_theme_tones){
        themecolor = data.global_theme_tones.replace('#', '');
      }else{
        themecolor = '42BD56';
      }
      me.themecolor = themecolor;
      window.AppThemeColor = themecolor;
      me.$utils.appendThemeColorStyleNode(themecolor);
      data.wap_tab_items.forEach((val, idx, arr) => {
        mystyle.innerHTML += '.btm-tabbar .icon-w[dataindex="'+idx+'"]{ background-image:url('+val.icon+'); } .btm-tabbar .item.router-link-exact-active .icon-w[dataindex="'+idx+'"]{ background-image:url('+val.icon_active+'); } ';
      });
      doc.getElementsByTagName('head')[0].appendChild(mystyle);

      var locationQueryDict = me.$utils.locationSearchParser(),
          isRedirected = typeof locationQueryDict.magshareredirect !== 'undefined' && parseInt(locationQueryDict.magshareredirect) === 1 ;
      if(isRedirected){
          $('.app-jump-overlay').fadeIn('fast', function () {
            $(this).find('.button-installed').attr('href', window.AppJumpProtocol+'://pagejump?jump_url='+me.jumpurl);
          });
      }
    });
  },
  mounted (){
    var me = this;
    $(document).on('click', '.hooker-for-jumpapp', function () {
      me.jumpToAppPage();
    });
    $('.app-jump-overlay').on('click', function(evt){
      if( !$(evt.target).hasClass('app-jump-dialog') && !$(evt.target).parents().hasClass('app-jump-dialog') ){
        $(this).fadeOut("fast");
      }
    });
  },
  methods: {
    goPostWshare (){
      if(this.isLimited) {
        location.href = this.appInfo.app_download;
      }else{
        router.push({
          name: 'WsharePost',
          query: {
            circle_id: this.$route.query.circle_id || '',
            name: this.$route.query.name || '',
            topic_name: this.$route.query.topic_name || '',
          }
        });
      }
    },
    goPostForum (){
      if(this.isLimited) {
        location.href = this.appInfo.app_download;
      }else{
        router.push({
          name: 'CirclePost',
          query: {
            circle_id: this.$route.query.circle_id,
            type_value: this.$route.query.type_value,
          }
        });
      }
    },
    jumpToAppPage (){
      if(this.$utils.clientSystemType.isWx){
        window.location.href = '/mag/index/v1/index/shareDownload';
      }else{
        var routeName = this.$route.name,
            jumpurl = this.appInfo.app_key + '://';
        var downloadUrl = this.appInfo.app_download;
        if(routeName === 'Index' || routeName === 'Circle' || routeName === 'Wshare' || routeName === 'Find' || routeName === 'User' || routeName === 'TopicHot' || routeName === 'UserHome' || routeName === 'CirclePost'){
          jumpurl = '';
        }
        switch (routeName) {
          case 'CirclePostList':
            jumpurl = jumpurl + 'forumThreadList?fid='+this.$route.query.type_value+'&circleId='+this.$route.query.circle_id;
            break;
          case 'WshareList':
            jumpurl = jumpurl + 'showList?circleId='+this.$route.query.circle_id;
            break;
          case 'PunchList':
            jumpurl = jumpurl + 'punchCardList?circle_id='+this.$route.query.circle_id;
            break;
          case 'TopicIndex':
            jumpurl = jumpurl + 'topicContentList?topic_id='+this.$route.query.id;
            break;
          case 'AllTools':
            jumpurl = jumpurl + 'toollist';
            break;
          case 'AllActivities':
            jumpurl = jumpurl + 'activitylist';
            break;
          case 'MineProfile':
            jumpurl = jumpurl + 'useredit';
            break;
          case 'UserFans':
            jumpurl = jumpurl + 'fanslist';
            break;
          case 'UserFollows':
            jumpurl = jumpurl + 'followlist';
            break;
          case 'FriendsDynamic':
            jumpurl = jumpurl + 'friendTimeline';
            break;
        }
        this.$utils.jumpToAppPage(jumpurl, downloadUrl);
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?9555efcc